module.exports = __webpack_public_path__ + "img/frh.0a0628e2.gif";